import { useTranslations } from 'next-intl';

export const ListingsListHeader = ({ children, desc, tag }) => {
  const t = useTranslations();
  const Tag = tag ? tag : 'h1';

  return (
    <section className="max-sm:pt-4 pt-6 max-sm:space-y-1.5 space-y-2">
      <Tag className="text-primary-800 text-2xl font-semibold tracking-[0.2px]">
        {children}
      </Tag>
      {desc && (
        <p
          className="text-neutral-400 max-sm:text-sm sm:text-base sm:leading-7"
          dangerouslySetInnerHTML={{ __html: t.raw(desc) }}
        />
      )}
    </section>
  );
};
